<template>
  <div>
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="data_view">
        <div class="left-tab-label" slot="label">
          <div class="label-title">Data View</div>
          <div class="label-desc">data view</div>
        </div>
        <keep-alive>
          <DataView
            ref="dataView"
            :podData="podData"
            :screenWidth="screenWidth"
            v-if="activeName === 'data_view'"
          />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane name="chart_view">
        <div class="left-tab-label" slot="label">
          <div class="label-title">Chart View</div>
          <div class="label-desc">
            chart view
          </div>
        </div>
        <keep-alive>
          <ChartView
            ref="chartView"
            :podData="podDataForChart"
            :screenWidth="screenWidth"
            v-if="activeName === 'chart_view'"
          ></ChartView>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <el-tooltip placement="top">
      <div slot="content">
        {{
          connectionStatus === 0
            ? 'Connecting to Smartz® service...'
            : connectionStatus === 1
            ? 'Successfully connected to Smartz® service.'
            : 'Failed to connect to Smartz® service.'
        }}
      </div>
      <div
        class="connection-status"
        :class="
          connectionStatus === 2
            ? 'red-bg'
            : connectionStatus === 1
            ? 'green-bg'
            : ''
        "
      >
        {{
          connectionStatus === 0
            ? 'Connecting...'
            : connectionStatus === 1
            ? 'Connected'
            : 'Disconnected'
        }}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import ChartView from '@/components/pods/liveData/ChartView'
import DataView from '@/components/pods/liveData/DataView'
import Vue from 'vue'
import moment from 'moment-timezone'

export default {
  data() {
    return {
      activeName: 'data_view',
      screenWidth: window.innerWidth,
      podData: [],
      podDataForChart: [],
      connectionStatus: 2 // 0: Connecting, 1: Connected, 2: Disconnected
    }
  },
  mounted: function() {
    this.initSignalR()

    this.$hub.$on('pod-data-received', this.onPodDataReceived)
    window.addEventListener('resize', this.getScreenWidth)
  },
  components: {
    ChartView,
    DataView
  },
  watch: {
    '$store.state.pods.selectedPod'() {
      this.podData = []
      this.podDataForChart = []
      this.addNewToGroup()
    },
    '$store.state.pods.selectedUtcOffset': function() {
      this.podData = this.podData.map(data => {
        return {
          ...data,
          timeStampWithUtc: moment
            .utc(data.timeStamp)
            .tz(this.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
      })
      this.podDataForChart = this.podDataForChart.map(data => {
        return {
          ...data,
          timeStampWithUtc: moment
            .utc(data.timeStamp)
            .tz(this.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
      })
    }
  },
  methods: {
    initSignalR() {
      this.connectionStatus = 0
      Vue.prototype
        .startSignalR()
        .then(() => {
          this.connectionStatus = 1
        })
        .catch(() => {
          this.connectionStatus = 2
        })
    },
    addNewToGroup() {
      this.connectionStatus = 0
      Vue.prototype
        .addToGroup()
        .then(() => {
          this.connectionStatus = 1
        })
        .catch(() => {
          this.connectionStatus = 2
        })
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    onPodDataReceived(data) {
      if (data.podMac === this.$store.state.pods.selectedPod.podId) {
        let calculatedData = {
          ...data,
          timeStampWithUtc: moment
            .utc(data.timeStamp)
            .tz(this.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
        this.podData.push(calculatedData)

        if (!this.podDataForChart.length) {
          this.podDataForChart.push(calculatedData)
        } else {
          // sensor values & accelerometer values (ax, ay, az) are only on even tickcounter
          // battery and temperature is on odd tickcounter
          // connection status in on both even & odd
          let prevData = this.podDataForChart[this.podDataForChart.length - 1]
          if (data.tickCounter % 2 === 0) {
            this.podDataForChart.push({
              ...calculatedData,
              batteryVoltage: prevData.batteryVoltage,
              temperature: prevData.temperature
            })
          } else {
            this.podDataForChart.push({
              ...calculatedData,
              sensor1Value: prevData.sensor1Value,
              sensor2Value: prevData.sensor2Value,
              ax: prevData.ax,
              ay: prevData.ay,
              az: prevData.az
            })
          }
        }
      }
    }
  },
  destroyed() {
    Vue.prototype.stopSignalR()
  }
}
</script>

<style lang="scss" scoped>
.connection-status {
  padding: 5px 10px;
  font-weight: bold;
  font-size: 14px;
  position: fixed;
  right: 30px;
  top: 95px;
  background-color: #bbb;
  color: white;
  border-radius: 5px;
  &.red-bg {
    background-color: #ff4d4d;
  }
  &.green-bg {
    background-color: #4caf50;
  }
}
</style>
